module.exports = __webpack_public_path__ + "static/media/top_graphic.52594326.svg";